<div class="error">
  <img src="/assets/icons/icon-error.svg" alt="{{ 'imgAlt.error' | translate }}" />
  {{ errorMessage }}
</div>
